import React, { useState, useEffect } from "react";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";
import NCReviewReport from "../modal/NCReviewReport";
import axios from "axios";
import { toast } from "react-toastify";
import config from "../../config/config";
import { getAuthToken } from "../../utils/token";
import { formatDate } from "../../utils/formatDate";
import Loader from "../loader/Loader";

const NCValidationModal = ({ show, handleClose, verifyId ,refreshParent}) => {
  const [nCReviewReport, setNCReviewReport] = useState(false);
  const [ncVerification, setNcVerification] = useState([]);
  const [loading, setLoading] = useState(false);
  const [description, setDescription] = useState("");

  const fetchNcVerification = async () => {
    const token = getAuthToken();
    if (!token) return;

    try {
      setLoading(true);
      const response = await axios.get(
        `${config.API}/manager/verifyeffectiveactionget/${verifyId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data?.success) {
        setNcVerification(response.data);
      }
    } catch (err) {
      console.error("Error fetching NC Verification", err);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async () => {
    if (!description.trim()) {
      toast.warn("Please enter notes");
      return;
    }

    const token = getAuthToken();
    if (!token) return;

    try {
      setLoading(true);
      const payload = {
        description: description,
      };
      const response = await axios.post(
        `${config.API}/manager/verifyeffectiveaction/${verifyId}`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (response.data?.success) {
        toast.success(response.data?.message);
        await refreshParent();
        handleClose();
        setDescription("");
      } 
    } catch (error) {
      console.error("Submit error", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (show && verifyId) fetchNcVerification();
  }, [show, verifyId]);

  return (
    <Modal show={show} onHide={handleClose} centered size="lg" className="font_family">
    {
      loading ? (
        <Loader/>
      ) :(
          <Modal.Body className="p-5">
        <h2 className="mb-3">NC Validation</h2>

        <div className="p-3 border rounded bg-light mb-4">
          <Row>
            <Col md={6}><strong>Product Name:</strong> {ncVerification?.production?.product?.name}</Col>
            <Col md={6}><strong>Product ID:</strong> {ncVerification?.production?.product?.product_code}</Col>
          </Row>
          <Row>
            <Col md={6}><strong>Qty NC:</strong> {ncVerification?.production?.nc_count}</Col>
            <Col md={6}>
              <strong>Report Date:</strong>{" "}
              {formatDate(ncVerification?.production?.created_at)}
            </Col>
          </Row>
          <Row>
            <Col md={6}><strong>Reported by:</strong> {ncVerification?.production?.user?.name}</Col>
            <Col md={6}>
              <strong>NC Type:</strong> {ncVerification?.production?.reason}
            </Col>
          </Row>

          <Button
            variant="outline-secondary"
            className="mt-3"
            onClick={() => setNCReviewReport(true)}
          >
            Review NC Report
          </Button>
        </div>

        <Form.Group className="mt-4">
          <Row>
            <Col md={2}>
              <Form.Label>Notes</Form.Label>
            </Col>
            <Col md={10}>
              <Form.Control
                as="textarea"
                rows={3}
                placeholder="Additional notes or observations"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
              />
            </Col>
          </Row>
        </Form.Group>
      </Modal.Body>
      )
    }

      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose} disabled={loading}>
          Close
        </Button>
        <Button variant="dark" onClick={handleSubmit} disabled={loading}>
          Submit
        </Button>
      </Modal.Footer>

      <NCReviewReport
        verifyId={verifyId}
        show={nCReviewReport}
        handleClose={() => setNCReviewReport(false)}
      />
    </Modal>
  );
};

export default NCValidationModal;